export const STRATEGY_PERSONALISE_FILTER_KEYS = {
  order: 'order',
  orderBy: 'orderBy',
  filterBy: 'filterBy',
};

//Shared by the Personalise and Metrics tabs, which show one toggle between them
export const STRATEGY_MY_CONTACTS_KEY = 'myContacts';

export const STRATEGY_METRICS_FILTER_KEYS = {
  filterStatus: 'filterStatus',
};

export const STRATEGY_PARAM_KEYS = {
  createMode: 'createMode',
  filters: 'filters',
  search: 'search',
};
